module.exports = __webpack_public_path__ + "avatar-0992404040319c0fbe2c.png";